import React from 'react';
import { Box, Breakpoint } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import { StyledHeading, StyledTypography } from './styles/styles';
import { Palette } from 'Palette';
import StyledSection from './styles/StyledSection';

type SectionBlock = {
  title?: string;
  content: string;
  bold?: boolean;
};

type ContentSectionProps = {
  title: string;
  subtitle?: string;
  description?: string;
  blocks?: SectionBlock[];
  tone?: keyof typeof Palette;
  noSidePaddingFrom?: Breakpoint;
  noTopPadding?: boolean;
  sx?: SxProps<Theme>;
};

export const ContentSection = ({
  title,
  subtitle,
  description,
  blocks,
  tone = 'default',
  noSidePaddingFrom,
  noTopPadding,
  sx,
}: ContentSectionProps) => (
  <StyledSection
    tone={tone}
    additionalClassName={`react-ContentSection`}
    noSidePaddingFrom={noSidePaddingFrom}
    noTopPadding={noTopPadding}
    sx={sx}
  >
    <StyledHeading tone={tone}>{title}</StyledHeading>

    {subtitle && <StyledHeading headerVariant="heading2">{subtitle}</StyledHeading>}

    {description && <StyledTypography>{description}</StyledTypography>}

    {blocks?.map((block, index) => (
      <Box key={index} mb={index === blocks.length - 1 ? 0 : 3}>
        {block.title && <StyledHeading headerVariant="subheading">{block.title}</StyledHeading>}
        <StyledTypography sx={block.bold ? { fontWeight: '600' } : undefined}>
          {block.content}
        </StyledTypography>
      </Box>
    ))}
  </StyledSection>
);
